import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { isPastDate } from '../../utils/Utils';
import { getVoucherDetails } from '../../services/api/api';

const useVoucherHook = ({ voucherData: originalVoucherData }) => {
  const [voucherData, setVoucherData] = useState(originalVoucherData);
  const [isReady, setIsReady] = useState(false);
  const [iserror, setError] = useState('');

  const router = useRouter();

  const getVoucher = () => {
    getVoucherDetails(router.query.slug)
      .then(
        ({ balance, code, expiresAt, initialBalance, transactions, personalization, metadata }) => {
          const hasExpired = isPastDate(expiresAt);
          const formattedBalance = balance.toFixed(2);
          setVoucherData({
            ...voucherData,
            balance: formattedBalance,
            initialBalance,
            code,
            expiresAt,
            hasExpired,
            transactions,
            personalization,
            metadata,
          });
          setIsReady(true);
        }
      )
      .catch((error) => {
        setError(error.message);
      });
  };

  useEffect(() => {
    if (!router.query.slug) {
      setVoucherData({ ...voucherData });
      return;
    }

    getVoucher();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.query.slug]);
  return { iserror, voucherData, isReady };
};

export default useVoucherHook;
